import gql from 'graphql-tag'

export const profileSettingsQuery = gql`
  query profile {
    profileData: getResellerProfile {
      status
      displayDynamicBatch: display_dynamic_batch
      displayFixedBatch: display_fixed_batch
    }
  }
`

export const getDesignLabInfo = gql`
  query getDesignLabInfo {
    getDesignLabInfo {
      deliveryDays: delivery_days
      tutorialPlaylist: tutorial_playlist
      cutOffDays: cutoff_settings
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/TeamstoreTypes/data.ts